type RuntimeEnv = Partial<ImportMetaEnv> & {
  DEV?: boolean;
};

export const runtimeEnv: RuntimeEnv =
  typeof import.meta !== "undefined" &&
  typeof import.meta.env === "object" &&
  import.meta.env !== null
    ? (import.meta.env as RuntimeEnv)
    : {};
